import React, { useState, useEffect, useMemo } from "react";
import { useSelector } from "react-redux";

import AwardDashboard from "containers/Awards/Dashboard";
import AwardListView from "containers/Awards/List";
import { COLUMN_HEADER_KEYS, DEFAULT_AWARD_COLUMN_HEADERS } from "globals/constants";
import { useColumnHeaders, useFacetedSearch } from "hooks";
import { setAwardSearchBar } from "store/actions/awardList";
import { awardListSelectors } from "store/selectors";

import styles from "./styles.css";

const AGREEMENT_STATUS_COLUMN_ID = "related-agreement-status";

const AwardsMainView = () => {
	const AWARDS_LIST_ID = "awardsTable";

	const AWARDS_LIST_DEFAULT_COLUMNS = [
		DEFAULT_AWARD_COLUMN_HEADERS.AWARD_NUMBER,
		DEFAULT_AWARD_COLUMN_HEADERS.PI,
		DEFAULT_AWARD_COLUMN_HEADERS.PROJECT_TITLE,
		DEFAULT_AWARD_COLUMN_HEADERS.SPONSOR,
		DEFAULT_AWARD_COLUMN_HEADERS.SPONSOR_AWARD_NUMBER,
		DEFAULT_AWARD_COLUMN_HEADERS.PRIME_SPONSOR,
		DEFAULT_AWARD_COLUMN_HEADERS.INSTRUMENT_TYPE,
		DEFAULT_AWARD_COLUMN_HEADERS.AWARD_START_DATE,
		DEFAULT_AWARD_COLUMN_HEADERS.AWARD_END_DATE,
		DEFAULT_AWARD_COLUMN_HEADERS.ADMIN_UNIT,
		DEFAULT_AWARD_COLUMN_HEADERS.OBLIGATED_AMOUNT

	];

	const { columnHeaders: availableColumns, dashboardColumnHeaders } =
		useColumnHeaders(COLUMN_HEADER_KEYS.AWARD, {
			defaultColumnHeaders: AWARDS_LIST_DEFAULT_COLUMNS
		});

	const filteredColumns = useMemo(() =>
		(dashboardColumnHeaders ?? []).filter(({ id }) => id !== AGREEMENT_STATUS_COLUMN_ID),
	[ dashboardColumnHeaders ]);

	const { searchFacets, onSearchChange } = useFacetedSearch({
		availableColumns: filteredColumns,
		setSearchFragments: setAwardSearchBar,
	});

	const search = useSelector(awardListSelectors.search);
	const [ actualFacets, setActualFacets ] = useState({});


	useEffect(()=>{
		const reduxSearch = { ...search };
		const selectedFacets = {};
		Object.keys(reduxSearch).forEach(searchKey => {
			const facet = searchFacets.find(facet => facet.searchKey === searchKey);
			if (facet) {
				selectedFacets[facet.key] = reduxSearch[searchKey];
			}
		});
		setActualFacets(selectedFacets);
	},[ search, searchFacets ]);

	return (
		<div id="view-main-awards" className={styles.viewMainAwards}>
			<AwardDashboard dashboardTilesAriaControls={AWARDS_LIST_ID} searchFacets={searchFacets}
				onSearchChange={onSearchChange} actualFacets={actualFacets}
			/>
			<AwardListView awardsListId={AWARDS_LIST_ID}
				searchFacets={searchFacets}
				onSearchChange={onSearchChange}
				availableColumns={availableColumns}
				actualFacets={actualFacets}
			/>
		</div>
	);
};

export default AwardsMainView;
